import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { useMemo } from "react";

import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

import PriceLine from "./priceLine/priceLine.component";

type Props = {
    cart: CartModel;
};

const PriceSummary = ({ cart }: Props) => {
    const { t } = useGranite();

    const renderDeliveryCost = useMemo(
        () =>
            cart?.items.some(
                (i) =>
                    i.deliveryType === DeliveryType.HomeDelivery &&
                    !i.isAdditionalService
            ),
        [cart]
    );

    return (
        <>
            <PriceLine
                title={t("general.cart.totals.subTotal")}
                price={formatPrice(cart.subTotal)}
                borderWeight={0}
            />
            {renderDeliveryCost && (
                <PriceLine
                    title={t("general.cart.totals.deliveryCost")}
                    price={formatPrice(cart.deliveryCost, {
                        freeLabel: true,
                        t: t
                    })}
                />
            )}
            {cart.discountTotal && (
                <PriceLine
                    title={t("general.cart.totals.globalDiscounts")}
                    price={`-${formatPrice(cart.discountTotal)}`}
                />
            )}
            {cart.giftCardTotal && (
                <PriceLine
                    title={t("general.cart.totals.giftCards")}
                    price={`-${formatPrice(cart.giftCardTotal)}`}
                />
            )}

            <div className="font-weight-bold">
                <PriceLine
                    isTotalPrice={true}
                    title={t("general.cart.totals.total")}
                    price={formatPrice(cart.totalPrice)}
                    borderWeight={3}
                    test="priceLine-total"
                />
            </div>
        </>
    );
};

export default PriceSummary;
